// eslint-disable-next-line import/no-anonymous-default-export
export default (stats = [], action) => {
  switch (action.type) {
    case "GET_ALL_HEAD_OFFICE_CREDIT_STATS":
      return action.payload;
    default:
      return stats;
  }
};
